"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Shop =
/** @class */
function () {
  function Shop(obj) {
    this.shopId = obj.shopId;
    this.shopName = obj.shopName;
    this.shopDescription = obj.shopDescription;
    this.shopPhoto = obj.shopPhoto;
    this.shopPhoneNo = obj.shopPhoneNo;
    this.shopLatitude = obj.shopLatitude;
    this.shopLongitude = obj.shopLongitude;
    this.shopLandmark = obj.shopLandmark;
    this.address = obj.address;
    this.openHours = obj.openHours;
  }

  return Shop;
}();

exports.Shop = Shop;